export const homeMessages = {
  'home.actionCart': '加入购物车',
  'home.actionFavorite': '收藏',
  'home.adv1.desc': '所有商品均经过平台严格审核，假一赔十',
  'home.adv1.title': '正品保障',
  'home.adv2.desc': '主流城市48小时送达，部分地区次日达',
  'home.adv2.title': '极速配送',
  'home.adv3.desc': '7天无理由退换货，专属客服一对一服务',
  'home.adv3.title': '无忧售后',
  'home.adv4.desc': '每件商品可追溯产地来源，吃得放心',
  'home.adv4.title': '品质溯源',
  'home.btnBrowse': '立即逛逛 →',
  'home.btnDeals': '查看今日特惠',
  'home.catMore': '查看全部 →',
  'home.catTitle': '热门分类',
  'home.category1': '生鲜水果',
  'home.category2': '乳品饮品',
  'home.category3': '谷物粮油',
  'home.category4': '地方特产',
  'home.ctaBtn': '立即开始购物 →',
  'home.ctaDesc': '海量好物等你发现，全国产地直发，新鲜实惠',
  'home.ctaTitle': '开始你的品质购物之旅',
  'home.emptyProducts': '暂无在售商品，请稍后再来',
  'home.enterShop': '进店逛逛',
  'home.flashTagDeal': '限时特惠',
  'home.flashTagOff': '立减 {pct}%',
  'home.flashTip': '好物低价，限时抢购',
  'home.flashTitle': '限时特惠',
  'home.heroAsideLabel': '在售商品预览',
  'home.heroSub': '汇聚全国各地优质好物，从田间到餐桌，为你精选每一份品质生活',
  'home.heroTag': '跨地域数字贸易平台',
  'home.heroTitle': '产地直发，新鲜到家',
  'home.hotMore': '更多好物 →',
  'home.hotTitle': '热门推荐',
  'home.lead.cat': '按品类快速进入列表，所见即所得。',
  'home.lead.cta': '从浏览到下单，全程简单透明。',
  'home.lead.flash': '限时补贴与折扣款，适合囤货与尝新。',
  'home.lead.hot': '按销量与口碑排序，减少挑选成本。',
  'home.lead.shop': '认证店铺与经营数据，一眼判断靠谱程度。',
  'home.lead.why': '平台规则与履约能力，让每一次下单更安心。',
  'home.loadFail': '商品加载失败，请稍后刷新重试',
  'home.loadingHint': '商品加载中…',
  'home.shop1Desc': '专注新疆优质水果',
  'home.shop1Name': '新疆果园旗舰店',
  'home.shop2Desc': '黑土地原产好粮',
  'home.shop2Name': '东北粮仓直供',
  'home.shop3Desc': '原产地直发好茶',
  'home.shop3Name': '云南茶源优选',
  'home.shopGoodsSuffix': '件商品',
  'home.shopHighlight1': '近 30 日好评率 99.2% · 5 年店龄',
  'home.shopHighlight2': '产地直发占比 88% · 复购领先',
  'home.shopHighlight3': '茶类榜单 TOP · 顺丰合作',
  'home.shopTitle': '优质店铺',
  'home.soldPrefix': '已售',
  'home.statDelivery': '极速送达',
  'home.statProducts': '精选商品',
  'home.statProvinces': '覆盖省份',
  'home.statUsers': '活跃用户',
  'home.statUsersValue': '10万+',
  'home.trust1': '严选入驻与抽检',
  'home.trust2': '冷链与干线协同',
  'home.trust3': '7 天无忧售后',
  'home.trust4': '产地信息可追溯',
  'home.trustAria': '平台服务要点',
  'home.whyTitle': '为什么选择我们',
};
